import { SET_ALT_CHARGES } from '../actionTypes/AlternateChargeActionTypes';

export const setAltCharges = (altCharges) => ({
    type: SET_ALT_CHARGES,
    altCharges,
});
export default setAltCharges;
